import { createLookupTable } from '../utils';

const statuses = {
  UNKNOWN: 'error',
  sent: 'info',
  accepted: 'success',
  expired: 'default',
  rejected: 'error',
  cancelled: 'default',
  concept: 'default',
  pending: 'warning',
  ready: 'success',
  revised: 'default',
  deleted: 'error',
} as const;

export type QuotationLabel = keyof typeof quotationTable;
export const quotationTable = createLookupTable(statuses, 'quotation');
